import "./send-history-report.scss";

import React from "react";

import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as MailYellow } from "@client/components/reusable/SvgIcons/library/mail-yellow.svg";
import { useRootContext } from "@client/context/RootContext";
import { OrderStatuses } from "@client/stores";

import { SendHistoryReportModal } from "./send-history-report-modal";

export type SendHistoryReportProps = {
	timeFrameValue: number;
	status_names: OrderStatuses[];
};
export const SendHistoryReportButton: React.FC<SendHistoryReportProps> = (
	props
) => {
	const { modalStore } = useRootContext();

	return (
		<div
			onClick={() =>
				modalStore.addModal({
					id: "history-report-modal",
					content: <SendHistoryReportModal {...props} />,
					showCloseBtn2: true,
				})
			}
			className="btn-send-email"
		>
			<SvgIcon width="32" component={MailYellow} />
		</div>
	);
};
